<template>
<div>
    <!-- <section v-if="isShow" @mouseover="show=true" @mouseout="show=false">
        <div class="logo" @mouseover="$refs.shake.className = 'shake-pause'"  @click="goMoodle">
            <img ref="shake" :src="moodle" alt="">
        </div> -->
        
    <!-- </section>  -->
    <div class="side-menu-card moodle" v-if="isShow" @mouseover="show=true" @mouseout="show=false" @click="goMoodleMessagePage">
        <span>Moodle Message</span>
        <div class="moodle-menu">
        </div>

        <v-card
            v-show="show"
            max-width="400"
            elevation="7"
            class="common-card"
        >
            <div class="text-xs-left blue-title moodle-font"><strong>Moodle Message</strong></div>
            <div class="text-xs-left moodle-title moodle-font">{{Title}}</div>
            <v-card-text v-html="Content" class="px-0 blue-text-normal moodle-font pt-1">
                {{Content}}
            </v-card-text>
            <div class="text-xs-center">
                <!-- <v-btn round class="white--text moodle-btn-off" title=""  @click="goMoodle(1)">Official Exam</v-btn> -->
                <v-btn round class="white--text moodle-btn-exe" title=""  @click="goMoodle(2)">Exercise</v-btn>
            </div>
        </v-card>
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getMoodleMessage } from '@/api/message.js'
import { getToken } from '@/utils/auth'
import { setCookie, getCookie, clearCookie } from '@/utils/tools'
export default {
    data:()=>({
        isShow:true,
        show:false,
        Title:'',
        Content:'',
        CreateTime:null,
        id:null
    }),
    computed:{
        ...mapGetters(['user']),
    },
    mounted(){
        this.message()
        setInterval(()=>{
            this.message()
        },30000)
    //    var client = getCookie("client")
    //    if (client=="tutorclient") {
    //        this.isShow=false
    //    }
    },
    methods:{
        async message(){
            return
            // let resData = await getMoodleMessage().then(res=>{
            //     if(res.data.ErrorCode===0 && res.data.Body){
            //         return res.data.Body
            //     }else{
            //         return false
            //     }
            // })
            // if(resData){
            //     this.Content = this.httpString(resData.Content)
            //     this.Title = resData.Title
            //     this.CreateTime = resData.CreateTime
            // }
        },
        goMoodleMessagePage(){
            this.$router.push({ path: '/trainingCenter/moodleMessage' })
        },
        goMoodle(type){
            var host = window.location.host;
            var hostList = ["tutor.acadsoc.com","tutor.acadsoc.ph","info.acadsoc.ph","tutor.acadsoc.com.cn","classtable.acadsoc.ph"];
            if(hostList.indexOf(host)>-1){
                var sign=this.$store.state.user.entryKey

                var url=`https://tesolacadsoc.co.uk/auth/oidc?id_token=${getToken()}&state=${sign}`
                if(type==2){
                    url=`https://acadsoctraining.com/auth/oidc?id_token=${getToken()}&state=${sign}`
                }
                // console.log('sign',sign)
                // var url=`http://localhost/auth/oidc?id_token=${getToken()}&state=${sign}`
                window.open(url)
            }else{
                var sign=this.$store.state.user.entryKey
                var url=`http://192.168.74.93:8080/project/moodle/auth/oidc?id_token=${getToken()}&state=${sign}`
                // console.log('sign',sign)
                // var url=`http://localhost/auth/oidc?id_token=${getToken()}&state=${sign}`
                window.open(url)
            }
        },
        httpString(text) {
            if(!text) return
            var re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi;
            var s = text.replace(re,function(a){
                return '<a href="'+a+'" target=_blank>'+a+'</a>';
            });
            return s;
        }
    },
    watch:{
        'Title':function(value){
            if(value){
                this.$refs.shake.className = 'shake'
            }
        }
    }
}
</script>
<style scoped>
.moodle-font{
    font-size: 12px;
    line-height: 24px;
}
section{
    z-index: 99;
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
}
.logo{
    width: 60px;
    height: 60px; 
}
img{
    width: 60px;
    height: 60px;
     -webkit-box-shadow: 0 7px 18px 0px #a9a9a9;
    box-shadow: 0 7px 18px 0px #a9a9a9;
    border-radius: 50%;
}
.v-card{
    width: 320px;
    min-height: 160px;
    position: absolute;
    left: 38px;
    bottom: -80px;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19);
}
.moodle-title{
    color: rgba(50, 57, 122, 0.8);
}
.moodle-btn-off{
    background-color: #14259B!important;
    border-radius: 4px;
    width:110px;
    height: 22px;
    min-width: 48px;
    box-shadow: none!important;
    font-size: 12px;
}
.moodle-btn-exe{
    background-color: #FF9991!important;
    border-radius: 4px;
    width:110px;
    height: 22px;
    min-width: 48px;
    box-shadow: none!important;
    font-size: 12px;
}
.arrow{
    position:absolute;
    right:-12px;
}
.shake-pause {
animation-play-state:paused;
-webkit-animation-play-state:paused; /* Safari 和 Chrome */
}
.shake{
    animation: shaky-slow 2s infinite;
    -webkit-animation:shaky-slow 2s infinite;
}
@keyframes shaky-slow {
        0% {            transform: translate(0px, 0px) rotate(0deg);
        }
        2% {            transform: translate(-1px, 1.5px) rotate(1.5deg);
        }
        4% {            transform: translate(1.3px, 0px) rotate(-0.5deg);
        }
        6% {            transform: translate(1.4px, 1.4px) rotate(-2deg);
        }
        8% {            transform: translate(-1.3px, -1px) rotate(-1.5deg);
        }
        10% {            transform: translate(1.4px, 0px) rotate(-2deg);
        }
        12% {            transform: translate(-1.3px, -1px) rotate(-2deg);
        }
        14% {            transform: translate(1.5px, 1.3px) rotate(1.5deg);
        }
        16% {            transform: translate(1.5px, -1.5px) rotate(-1.5deg);
        }
        18% {            transform: translate(1.3px, -1.3px) rotate(-2deg);
        }
        20% {            transform: translate(1px, 1px) rotate(-0.5deg);
        }
        22% {            transform: translate(1.3px, 1.5px) rotate(-2deg);
        }
        24% {            transform: translate(-1.4px, -1px) rotate(2deg);
        }
        26% {            transform: translate(1.3px, -1.3px) rotate(0.5deg);
        }
        28% {            transform: translate(1.6px, -1.6px) rotate(-1.5deg);
        }
        30% {            transform: translate(-1.3px, -1.3px) rotate(-1.5deg);
        }
        32% {            transform: translate(-1px, 0px) rotate(2deg);
        }
        34% {            transform: translate(1.3px, 1.3px) rotate(-0.5deg);
        }
        36% {            transform: translate(1.3px, 1.6px) rotate(1.5deg);
        }
        38% {            transform: translate(1.3px, -1.6px) rotate(1.5deg);
        }
        40% {            transform: translate(-1.4px, -1px) rotate(-0.5deg);
        }
        42% {            transform: translate(-1.4px, 1.3px) rotate(-0.5deg);
        }
        44% {            transform: translate(-1.6px, 1.4px) rotate(0.5deg);
        }
        46% {            transform: translate(-2.1px, -1.3px) rotate(-0.5deg);
        }
        48% {            transform: translate(1px, 1.6px) rotate(1.5deg);
        }
        50% {            transform: translate(1.6px, 1.6px) rotate(1.5deg);
        }
        52% {            transform: translate(-1.4px, 1.6px) rotate(0.5deg);
        }
        54% {            transform: translate(1.6px, -1px) rotate(-2deg);
        }
        56% {            transform: translate(1.3px, -1.6px) rotate(-2deg);
        }
        58% {            transform: translate(-1.3px, -1.6px) rotate(0.5deg);
        }
        60% {            transform: translate(1.3px, 1.6px) rotate(-0.5deg);
        }
        62% {            transform: translate(0px, 0px) rotate(-1.5deg);
        }
        64% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        66% {            transform: translate(1.6px, -1.6px) rotate(0.5deg);
        }
        68% {            transform: translate(0px, -1.6px) rotate(-2deg);
        }
        70% {            transform: translate(-1.6px, 1px) rotate(1.5deg);
        }
        72% {            transform: translate(-1.6px, 1.6px) rotate(2deg);
        }
        74% {            transform: translate(1.3px, -1.6px) rotate(-0.5deg);
        }
        76% {            transform: translate(1.4px, 1px) rotate(-0.5deg);
        }
        78% {            transform: translate(-1px, 1.4px) rotate(2deg);
        }
        80% {            transform: translate(1.4px, 1.6px) rotate(2deg);
        }
        82% {            transform: translate(-1.6px, -1.6px) rotate(-0.5deg);
        }
        84% {            transform: translate(-1.4px, 1.4px) rotate(-2deg);
        }
        86% {            transform: translate(1px, 1.4px) rotate(-2deg);
        }
        88% {            transform: translate(-1.4px, 1.4px) rotate(-1.5deg);
        }
        90% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        92% {            transform: translate(-1.4px, 1.6px) rotate(2deg);
        }
        94% {            transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        96% {            transform: translate(-1.4px, 1.3px) rotate(-2deg);
        }
        98% {            transform: translate(1.3px, 1px) rotate(-0.5deg);
        }
}
@-webkit-keyframes shaky-slow {
        0% {            -webkit-transform: translate(0px, 0px) rotate(0deg);
        }
        2% {            -webkit-transform: translate(-1px, 1.5px) rotate(1.5deg);
        }
        4% {            -webkit-transform: translate(1.3px, 0px) rotate(-0.5deg);
        }
        6% {            -webkit-transform: translate(1.4px, 1.4px) rotate(-2deg);
        }
        8% {            -webkit-transform: translate(-1.3px, -1px) rotate(-1.5deg);
        }
        10% {            -webkit-transform: translate(1.4px, 0px) rotate(-2deg);
        }
        12% {            -webkit-transform: translate(-1.3px, -1px) rotate(-2deg);
        }
        14% {            -webkit-transform: translate(1.5px, 1.3px) rotate(1.5deg);
        }
        16% {            -webkit-transform: translate(1.5px, -1.5px) rotate(-1.5deg);
        }
        18% {            -webkit-transform: translate(1.3px, -1.3px) rotate(-2deg);
        }
        20% {            -webkit-transform: translate(1px, 1px) rotate(-0.5deg);
        }
        22% {            -webkit-transform: translate(1.3px, 1.5px) rotate(-2deg);
        }
        24% {            -webkit-transform: translate(-1.4px, -1px) rotate(2deg);
        }
        26% {            -webkit-transform: translate(1.3px, -1.3px) rotate(0.5deg);
        }
        28% {            -webkit-transform: translate(1.6px, -1.6px) rotate(-2deg);
        }
        30% {            -webkit-transform: translate(-1.3px, -1.3px) rotate(-1.5deg);
        }
        32% {            -webkit-transform: translate(-1px, 0px) rotate(2deg);
        }
        34% {            -webkit-transform: translate(1.3px, 1.3px) rotate(-0.5deg);
        }
        36% {            -webkit-transform: translate(1.3px, 1.6px) rotate(1.5deg);
        }
        38% {            -webkit-transform: translate(1.3px, -1.6px) rotate(1.5deg);
        }
        40% {            -webkit-transform: translate(-1.4px, -1px) rotate(-0.5deg);
        }
        42% {            -webkit-transform: translate(-1.4px, 1.3px) rotate(-0.5deg);
        }
        44% {            -webkit-transform: translate(-1.6px, 1.4px) rotate(0.5deg);
        }
        46% {            -webkit-transform: translate(-2.1px, -1.3px) rotate(-0.5deg);
        }
        48% {            -webkit-transform: translate(1px, 1.6px) rotate(1.5deg);
        }
        50% {            -webkit-transform: translate(1.6px, 1.6px) rotate(1.5deg);
        }
        52% {            -webkit-transform: translate(-1.4px, 1.6px) rotate(0.5deg);
        }
        54% {            -webkit-transform: translate(1.6px, -1px) rotate(-2deg);
        }
        56% {            -webkit-transform: translate(1.3px, -1.6px) rotate(-2deg);
        }
        58% {            -webkit-transform: translate(-1.3px, -1.6px) rotate(0.5deg);
        }
        60% {            -webkit-transform: translate(1.3px, 1.6px) rotate(-0.5deg);
        }
        62% {            -webkit-transform: translate(0px, 0px) rotate(-1.5deg);
        }
        64% {            -webkit-transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        66% {            -webkit-transform: translate(1.6px, -1.6px) rotate(0.5deg);
        }
        68% {            -webkit-transform: translate(0px, -1.6px) rotate(-2deg);
        }
        70% {            -webkit-transform: translate(-1.6px, 1px) rotate(1.5deg);
        }
        72% {            -webkit-transform: translate(-1.6px, 1.6px) rotate(2deg);
        }
        74% {            -webkit-transform: translate(1.3px, -1.6px) rotate(-0.5deg);
        }
        76% {            -webkit-transform: translate(1.4px, 1px) rotate(-0.5deg);
        }
        78% {            -webkit-transform: translate(-1px, 1.4px) rotate(2deg);
        }
        80% {            -webkit-transform: translate(1.4px, 1.6px) rotate(2deg);
        }
        82% {            -webkit-transform: translate(-1.6px, -1.6px) rotate(-0.5deg);
        }
        84% {            -webkit-transform: translate(-1.4px, 1.4px) rotate(-2deg);
        }
        86% {            -webkit-transform: translate(1px, 1.4px) rotate(-2deg);
        }
        88% {            -webkit-transform: translate(-1.4px, 1.4px) rotate(-1.5deg);
        }
        90% {            -webkit-transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        92% {            -webkit-transform: translate(-1.6px, 1.6px) rotate(2deg);
        }
        94% {            -webkit-transform: translate(-1.6px, -1.6px) rotate(-2deg);
        }
        96% {            -webkit-transform: translate(-1.4px, 1.3px) rotate(-2deg);
        }
        98% {            -webkit-transform: translate(1.3px, 1px) rotate(-0.5deg);
        }
    }

</style>